function centsToDollar(cents?: number, removeTrailingCents?: boolean) {
  if (!cents || isNaN(cents)) return `$0.00`;
  let data = '';
  const negative = cents < 0;
  const absolute = Math.abs(cents);
  if (absolute % 100 < 10) {
    data = String(Math.floor(absolute / 100) + `.0${absolute % 100}`);
  } else {
    data = String(Math.floor(absolute / 100) + `.` + (absolute % 100));
  }
  let finalData = data.replace(/\d(?=(\d{3})+\.)/g, '$&,');
  if (removeTrailingCents) {
    finalData = finalData.replace(/\.00$/, '');
  }
  return `$${negative ? '-' : ''}${finalData}`;
}

export { centsToDollar };
